<template>
  <div>
    <el-row class="container" style="margin-top:15px;" :gutter="20">
      <!-- Columna Filtros -->
      <el-col class="container_col_1" :span="6">
        <!-- Header filtros-->
        <el-row style="margin-bottom:15px;">
          <el-col :span="16">
            <div class="title">{{ $t('NAVBAR_expire_warranty') }}</div>
          </el-col>
          <el-col :span="8">
            <!-- botón exportar icon="el-icon-download"-->
            <el-button
              v-if="garantias !== undefined && garantias.length > 0"
              class="btn-exportar"
              type="primary"
              size="small"
              :loading="exportandoGarantias"
              @click="exportarGarantias"
              round
            >{{ $t('GENERAL_exportBtn') }}</el-button>
          </el-col>
        </el-row>
        <!-- Filtros -->
        <el-row>
          <el-collapse v-model="activeNames">
            <el-collapse-item :title="$t('GENERAL_Busqueda_Simple')" name="1">
              <div class="filters">
                <div class="filters_item">
                  <el-row style="text-align:left;">
                    <el-col :span="2">
                      <el-checkbox                                       
                      v-model="filtros.checkPeriodo"
                      size="medium"
                      @change="changeCheck('P')">
                      </el-checkbox>
                    </el-col>
                    <el-col :span="20" style="text-align:left !important;">
                      <el-dropdown trigger="click" @command="changePeriodo">
                        <span
                          :class="{'el-dropdown-link': filtros.checkPeriodo, 'el-dropdown-link-active': !filtros.checkPeriodo }"
                        >
                          {{this.$t(filtros.periodo)}}
                          <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            command="GARANTIAS_venc_garantia_meses_1"
                            :disabled="filtros.checkRango">{{$t('GARANTIAS_venc_garantia_meses_1')}}</el-dropdown-item>
                          <el-dropdown-item
                            command="GARANTIAS_venc_garantia_meses_3"
                          :disabled="filtros.checkRango">{{$t('GARANTIAS_venc_garantia_meses_3')}}</el-dropdown-item>
                          <el-dropdown-item
                            command="GARANTIAS_venc_garantia_meses_menos_1"
                          :disabled="filtros.checkRango">{{$t('GARANTIAS_venc_garantia_meses_menos_1')}}</el-dropdown-item>
                          <el-dropdown-item
                            command="GARANTIAS_venc_garantia_meses_menos_12"
                          :disabled="filtros.checkRango">{{$t('GARANTIAS_venc_garantia_meses_menos_12')}}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      </el-col>
                  </el-row>
                </div>
                <div class="filters_item">
                  <el-row style="text-align:left; vertical-align:top;">
                    <el-col :span="2">
                      <el-checkbox
                        v-model="filtros.checkRango"
                        size="medium"
                        @change="changeCheck('R')">              
                      </el-checkbox>
                    </el-col>
                    <el-col :span="20">
                      <div class="label" style="padding-top:3px !important;">{{$t('GENERAL_desde')}}</div>
                      <el-date-picker
                        style="width:90%"
                        v-model="filtros.from"
                        type="date"
                        size="small"
                        format="dd/MM/yyyy"
                        suffix-icon="el-icon-date"
                        placeholder="dd/mm/aaaa"
                        @input="getGarantiasDelayed"
                        @change="getGarantiasDelayed"
                        :picker-options="pickerOptionsFrom"
                        :disabled="filtros.checkPeriodo"
                      />

                      <div class="label">{{$t('GENERAL_hasta')}}</div>
                      <el-date-picker
                        v-model="filtros.to"
                        style="width:90%"
                        type="date"
                        size="small"
                        format="dd/MM/yyyy"
                        suffix-icon="el-icon-date"
                        placeholder="dd/mm/aaaa"
                        @input="getGarantiasDelayed"
                        @change="getGarantiasDelayed"
                        :picker-options="pickerOptionsTo"
                        :disabled="filtros.checkPeriodo"
                      />
                    </el-col>
                  </el-row>
                </div>
              </div>

              <div class="clearFilters" @click="cleanFilters">{{$t('GENERAL_clean_filters')}}</div>
            </el-collapse-item>
          </el-collapse>
        </el-row>
      </el-col>

      <!-- Resultados de búsqueda -->
      <el-col class="container_col_2" :span="17">
        <!-- Header resultados de búsqueda -->
        <el-row style="margin-bottom:15px;">
          <el-col :xs="8" :sm="12" :md="10" :lg="16" :xl="16">
            <div class="sub-title">{{$t('GENERAL_resultado')}}</div>
          </el-col>
          <el-col :xs="16" :sm="12" :md="14" :lg="8" :xl="8" class="pagination_container">
            <el-pagination
              background
              small
              layout="prev, pager, next"
              :current-page="paginador.page"
              :page-count="paginador.nro_pages"
              :page-size="paginador.pageSize"
              :pager-count="5"
              @current-change="handlePageChange"
              hide-on-single-page
            ></el-pagination>
          </el-col>
        </el-row>
        <!-- Garantias -->
        <div class="card_list">
          <div v-if="loading" v-loading.lock="loading" class="loader"></div>

          <div
            v-else-if="garantias !== undefined && garantias.length > 0"
            class="card_list_item"
            v-for="garantia in garantias"
            :key="garantia.Ns"
          >
            <GarantiaCard :garantia="garantia" />
          </div>

          <div v-else class="loader">{{$t('GENERAL_no_data')}}</div>
        </div>
        <el-row></el-row>
      </el-col>
    </el-row>

    <!-- Paginador abajo -->
    <el-row style="margin-top:10px; margin-right:20px; text-align: right;">
      <el-col :span="23">
        <el-pagination
          background
          small
          layout="prev, pager, next"
          :current-page="paginador.page"
          :page-count="paginador.nro_pages"
          :page-size="paginador.pageSize"
          :pager-count="5"
          @current-change="handlePageChange"
          hide-on-single-page
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import GarantiaCard from "@/components/Cards/garantiaCard";
import { mapState } from "vuex";
import i18n from "../../plugins/i18n";

let defaultFiltros = {
  from: "",
  to: "",
  periodo: "GARANTIAS_venc_garantia_meses_1",
  tipo_filtro: "GARANTIAS_venc_garantia_periodo",
  checkPeriodo:true,
  checkRango:false
};

let defaultPaginador = {
  page: 1,
  pageSize: 20,
  nro_pages: 0
};

export default {
  name: "GarantiasProximaVencer",
  components: { GarantiaCard },
  data() {
    return {
      garantias: undefined,
      filtros: { ...defaultFiltros },
      paginador: { ...defaultPaginador },

      pickerOptionsFrom: {
        disabledDate: this.disabledDateFrom
      },
      pickerOptionsTo: {
        disabledDate: this.disabledDateTo
      },
      activeNames: ["1"],
      loading: false,
      exportandoGarantias: false
    };
  },
  computed: {
    ...mapState({
      idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario
    })
  },
  mounted() {
    this.getGarantiasAVencer();
  },
  methods: {
    changeCheck(check){
      if(check =='P'){
        this.filtros.checkRango = this.filtros.checkPeriodo == true? false : true;
        this.filtros.tipo_filtro = "GARANTIAS_venc_garantia_periodo";
      }
      else{ 
        this.filtros.checkPeriodo =this.filtros.checkRango == true? false:true;
        this.filtros.tipo_filtro = "GARANTIAS_venc_garantia_rango";
      }
    },
    handlePageChange(page) {
      this.paginador.page = page;
      this.getGarantiasAVencer();
    },

    disabledDateFrom(time) {
      if (this.filtros.to !== "") return time.getTime() > this.filtros.to;
      else return false;
    },

    disabledDateTo(time) {
      if (this.filtros.from !== "") return time.getTime() < this.filtros.from;
      else return false;
    },

    mapPeriodoToMeses() {
      switch (this.filtros.periodo) {
        case "GARANTIAS_venc_garantia_meses_1":
          return 1;
        case "GARANTIAS_venc_garantia_meses_3":
          return 3;
        case "GARANTIAS_venc_garantia_meses_menos_1":
          return -1;
        case "GARANTIAS_venc_garantia_meses_menos_12":
          return -12;
        default:
          return 1;
      }
    },

    changePeriodo(periodo) {
      this.filtros.periodo = periodo;
      this.getGarantiasAVencer();
    },

    getGarantiasDelayed() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        this.paginador = { ...defaultPaginador };
        this.getGarantiasAVencer();
      }, 1000);
    },

    getGarantiasAVencer() {
      this.loading = true;

      // armo el payload
      let payload = {};
      payload.idUsuario = this.idUsuario;
      payload.page = this.paginador.page;
      payload.pageSize = this.paginador.pageSize;

      if (
        this.filtros.tipo_filtro !== "GARANTIAS_venc_garantia_periodo"
      ) {
        payload.fechaDesde = this.filtros.from;
        payload.fechaHasta = this.filtros.to;
      } else payload.mesesADesfazar = this.mapPeriodoToMeses();

      // busco las garantías próximas a vencer
      this.$store
        .dispatch("garantias/getGarantiasAVencer", payload)
        .then(data => {
          this.garantias = data.Datos ? data.Datos.Garantias : [];
          this.paginador.nro_pages = data.Datos ? data.Datos.TotalPaginas : 0;
        })
        .finally(() => (this.loading = false));
    },

    exportarGarantias() {
      this.exportandoGarantias = true;

      // armo el payload
      let payload = {};
      payload.idUsuario = this.idUsuario;
      payload.idioma = i18n.locale;
      if (
        this.filtros.tipo_filtro !== "GARANTIAS_venc_garantia_periodo"
      ) {
        payload.fechaDesde = this.filtros.from;
        payload.fechaHasta = this.filtros.to;
      } else {
        payload.mesesADesfazar = this.mapPeriodoToMeses();
      }

      // exporto las ganartías
      this.$store
        .dispatch("garantias/exportarGarantiasVencidas", payload)
        .finally(() => (this.exportandoGarantias = false));
    },

    cleanFilters() {
      this.filtros = { ...defaultFiltros };
      this.paginador = { ...defaultPaginador };
      this.getGarantiasAVencer();
    }
  }
};
</script>

<style scoped>
.btn-exportar {
  padding-right: 0%;
  text-align: right;
}
.el-card {
  height: 100%;
}
.container {
  display: flex;
  min-height: 500px !important;
  width: 100% !important;
}
.pagination_container {
  text-align: right;
  padding-right: 0px;
}

@media (max-width: 600px) {
  .container {
    flex-direction: column;
  }
  .container_col_1 {
    flex: 1;
    width: 100% !important;
  }
  .container_col_2 {
    flex: 1;
    width: 100% !important;
    margin-top: 20px;
  }
}
.card_list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  grid-gap: 1rem;
}
.card_list_item {
  position: relative;
}
.title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: var(--main-color);
}
.sub-title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #999;
}
.filters {
  display: flex;
  flex-direction: column;
}
.filters_item {
  flex: 1;
  margin-bottom: 10px;
}
.label {
  text-align: left;
  margin-bottom: 4px;
  font-size: 14px;
}
.username {
  font-size: 14px;
  font-weight: bold;
  text-align: left;
}
.ns_dominio {
  font-size: 12px;
  font-weight: 100;
  color: #878585;
  text-align: left;
}
.tag {
  float: right;
  margin-top: 7px;
}
.info {
  margin-top: 20px;
}
.greyLabel {
  font-size: 14px;
  color: #6b6b6b;
  text-align: left;
  font-weight: normal;
}
.blackLabel {
  font-size: 14px;
  color: black;
  text-align: left;
  margin-bottom: 5px;
  font-weight: bold;
}
.switch {
  margin-left: 10px;
  margin-bottom: 2px;
}
.clearFilters {
  color: #5aabc6;
  font-size: 14px;
  text-align: left;
  margin-top: 10px;
  cursor: pointer;
}
.el-card__body {
  padding: 20px 40px;
}
.triangleRight {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 8px 0 8px 13.9px;
  border-color: transparent transparent transparent var(--main-color);
  position: absolute;
  left: 18px;
  top: 28px;
  cursor: pointer;
}
.triangleDown {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 13.9px 8px 0 8px;
  border-color: var(--main-color) transparent transparent transparent;
  position: absolute;
  left: 18px;
  top: 28px;
  cursor: pointer;
}
.cardBody {
  padding-left: 25px;
}
.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.button {
  position: fixed;
  bottom: 40px;
  right: 40px;
}
.soonToExpire {
  font-size: 14px;
  color: #2e2e2e;
  font-weight: bold;
  text-align: left;
}
.el-radio-group {
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-top: 14px;
}
.el-radio {
  line-height: 2;
}
.el-dropdown-link {
  cursor: pointer;
  color: #a0a0a0;
}
.el-dropdown-link-active {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.from_to {
  position: relative;
  display: inline-block;
}

.loader {
  margin-top: 25%;
  color: #999;
}
</style>
